export default {
  PCUSTOMSection: {
    title: 'Projet personnalisé',
    delete_calcul: 'Etes-vous sur de vouloir supprimer ce calcul ?',
    rename_calcul: 'Renomer le calcul',
    document: {
      createFolder: 'Créer un dossier',
      createFolderEvo: 'Creer dossier evolutif',
      folderTitle: 'Nom du dossier',
      errorFolderTile: 'Le nom du dossier ne peut pas être vide',
      lastUpdate: 'Mise à jour : {{lastUpdate}}'
    }
  }
}
